<div class="notification-item"
    [class.notification-item--unread]="!notification.isRead"
    (click)="onItemClick()">

    <div class="notification-item__icon-wrapper">
        @if (showSystemLogo) {
            <mine-service-icon
                class="notification-item__service-icon shadow"
                [icon]="systemId | systemIdToIcon"
                [width]="20"
                [height]="20">
            </mine-service-icon>
        } @else {
            <svg class="notification-item__icon notification-item__icon--{{iconId}}">
                <use [attr.xlink:href]="'assets/img/sprite.svg#' + iconId"></use>
            </svg>
        }
    </div>

    <div class="notification-item__content">
        <div class="notification-item__header">
            <div class="notification-item__text-block">
                @if (showTitle) {
                    <p class="notification-item__title" [innerHTML]="notification.title"></p>
                }

                @if (notification.body) {
                    <p
                        class="notification-item__body"
                        [class.notification-item__body--standalone]="!showTitle"
                        [innerHTML]="notification.body">
                    </p>
                }
            </div>

            <div class="notification-item__meta">
                <span class="notification-item__date">{{ notification.createdAt | date: 'MMM d' }}</span>
                @if (!notification.isRead) {
                    <span class="notification-item__unread-dot"></span>
                }
            </div>
        </div>
    </div>

    <div class="notification-item__menu-area"
        [class.notification-item__menu-area--open]="isMenuOpen()"
        (click)="$event.stopPropagation()">
        <notification-action-menu class="notification-item__action-menu small"
            [options]="contextMenuOptions"
            [position]="menuPosition"
            [panelStyle]="{ 'right': '0', 'left': 'unset' }"
            (menuOpened)="isMenuOpen.set(true)"
            (menuClosed)="isMenuOpen.set(false)"
            (action)="onContextMenuAction($event)">
        </notification-action-menu>
    </div>
</div>
